import React, {Component} from 'react';
import styles from './style/styles';
import {
    withStyles,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui';

class WebinarDeleteDialog extends Component {
    render() {
        const {handleSubmit, handleRequestClose, open, classes} = this.props;

        return (
            <Dialog open={open} onClose={handleRequestClose}>
                <DialogTitle>{'Delete Webinar'}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the webinar?
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button onClick={handleRequestClose} variant="raised">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="raised"
                        color="primary"
                        type="submit"
                        autoFocus
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(WebinarDeleteDialog);



// WEBPACK FOOTER //
// ./src/containers/webinars/WebinarDeleteDialog.jsx